import Route from '@ember/routing/route';

export default class EntriesIndividualRoute extends Route 
{
	model() 
	{
		return this.modelFor("event");
	}
}
